import { Menu, MenuItem, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LoadingButton } from "@mui/lab";
import ConfirmPopup from "src/shared/components/confirmation-popup";
import { useCancelGolfCartRequestMutation } from "src/api/golf-carts";

const TableActions = ({
  requestId,
  refetch,
  requestStatus,
}: {
  requestId: string;
  refetch: Function;
  requestStatus: string;
}) => {
  const navigate = useNavigate();
  const [openPopup, setOpenPopup] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // apis
  const { mutate, isPending } = useCancelGolfCartRequestMutation();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenPopup = () => {
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const handleNavigateToViewPage = () => {
    navigate(`/golf-requests/${requestId}`);
  };

  const handleCancel = () => {
    mutate(
      { requestId },
      {
        onSuccess: (data) => {
          console.log("success", data);
          refetch?.();
          setOpenPopup(false);
          setAnchorEl(null);
        },
        onError: (err) => {
          console.error("error", err);
          setAnchorEl(null);
        },
      },
    );
  };

  return (
    <Stack direction={"row"}>
      <LoadingButton
        variant="contained"
        color="inherit"
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleClick}
        size="small"
        sx={{ fontSize: "12px", color: "#7E8299", fontWeight: 600 }}
      >
        Actions
      </LoadingButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={handleNavigateToViewPage}
          sx={{ width: "105px", color: "primary.main" }}
        >
          View
        </MenuItem>
        {requestStatus === "pending" && (
          <MenuItem onClick={handleOpenPopup}>Cancel</MenuItem>
        )}
      </Menu>

      {/* confirm unassign */}
      <ConfirmPopup
        open={openPopup}
        setOpen={setOpenPopup}
        handleClose={handleClosePopup}
        subtitle="This action will cancel this request"
        submitBtnLabel="Cancel Request"
        onSave={handleCancel}
        isLoading={isPending}
      />
    </Stack>
  );
};
export default TableActions;
